// İSG uzmanı portalı — genel amaçlı süzgeç-çip grubu (S34-4, `pages/security/DayListTab.tsx`'in
// yerel `DayFilterGroup`'undan GENELLEŞTİRİLEREK taşındı). WAI-ARIA "Button Group" deseni:
// `role="group"` + her seçenek gerçek bir `<button aria-pressed>` — `<fieldset>` DEĞİL (o form
// denetimleri/radio-checkbox içindir, burada uygun semantik değil; eski dosyanın gerekçesi
// aynen geçerli).
//
// Eski bileşen `ViewFilter` (yalnız `'all' | 'allowed'`) için sabitti; Panel'in "Aksiyon
// gerekli" listesi (`ExpertActionItemKind | 'all'`) AYNI görsel deseni farklı bir değer
// kümesiyle istediği için tek kopya yerine bu dosya jenerik `T extends string` alır.

export interface FilterChipOption<T extends string> {
  value: T;
  label: string;
  count: number;
}

export function FilterChipGroup<T extends string>({
  options,
  value,
  onChange,
  groupLabel,
  wrap = true,
}: {
  options: FilterChipOption<T>[];
  value: T;
  onChange: (value: T) => void;
  /** `role="group"`in erişilebilir adı — çağıran her zaman kendi i18n anahtarını verir. */
  groupLabel: string;
  /**
   * S36 #15c — `false` yalnız `ActionItemsPanel` içindir. Bu grup `PanelHeader`in `right`
   * yuvasında başlığın YANINDA oturur; grup KENDİ İÇİNDE sarabildiği (`flex-wrap`) sürece
   * `PanelHeader`in DIŞ satırı hiçbir zaman "sığmıyor" görmez — sonuç, ~1100px'te başlığın
   * yanında SIKIŞIK 2 satır çip (triage `FilterChipGroup.tsx:33`). `wrap={false}` bu grubu
   * `flex-nowrap` yapar; artık grup dar satıra sığmayınca DIŞ `PanelHeader` satırı (kendi
   * `flex-wrap`i) devreye girer ve TÜM grubu başlığın ALTINA, panelin tam genişliğine düşürür
   * — tek satırda 4 çip, panelin dar sağ sütununda bile. `DayListTab.tsx`'in 2 çipli kullanımı
   * asla bu genişliğe sığmadığı için varsayılan `true` DEĞİŞMEDİ.
   */
  wrap?: boolean;
}) {
  return (
    // WAI-ARIA "Button Group" deseni (`DayListTab.tsx`'in eski yerel `DayFilterGroup`'uyla
    // AYNI) — <fieldset> form denetimleri (radio/checkbox) içindir, burada uygun semantik DEĞİL.
    // biome-ignore lint/a11y/useSemanticElements: role="group" kasıtlı, yukarıdaki not
    <div
      role="group"
      aria-label={groupLabel}
      className={`inline-flex items-center gap-1 rounded-md border border-border p-0.5 ${
        wrap ? 'flex-wrap' : 'flex-nowrap'
      }`}
    >
      {options.map((option) => {
        const isActive = value === option.value;
        return (
          <button
            key={option.value}
            type="button"
            aria-pressed={isActive}
            onClick={() => onChange(option.value)}
            className={`inline-flex items-center rounded px-2.5 py-1 text-xs font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ${
              isActive
                ? 'bg-primary text-primary-foreground'
                : 'text-muted hover:bg-surface-muted hover:text-fg'
            }`}
          >
            {option.label}
            {/* S34-45 design review M8 — aktif rozetin `bg-primary-foreground/20` tonu `#0f62fe`
                üstünde ~`#3f81fe`e bileşiyordu; beyaz 11px metin orada ~3.6:1 (4.5:1 ALTI). Ton
                TAMAMEN kaldırıldı — düz beyaz metin `bg-primary` üstünde ~5.0:1; ayrım artık
                RENK TONUNDAN değil `font-semibold` ağırlığından gelir. */}
            <span
              className={`ml-1 rounded px-1.5 py-0.5 text-[11px] tabular-nums ${
                isActive
                  ? 'font-semibold text-primary-foreground'
                  : 'bg-surface-muted font-medium text-muted'
              }`}
            >
              {option.count}
            </span>
          </button>
        );
      })}
    </div>
  );
}
